import React from 'react';

const PageHero = ({ overline, title, subtitle, children, testId = 'page-hero' }) => (
  <section
    data-testid={testId}
    className="relative pt-36 pb-20 md:pt-44 md:pb-28 px-6 md:px-12 overflow-hidden"
  >
    <div className="absolute inset-0 liquid-bg opacity-80" aria-hidden />
    <div className="relative max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-8 md:col-start-2 reveal-up">
        {overline && (
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#90B0BF] mb-6">
            <span className="label-divider" />{overline}
          </p>
        )}
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-[#7C9CB1] leading-[0.95] tracking-tight font-light">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-8 max-w-2xl text-lg md:text-xl font-light text-[#7C9CB1]/85 leading-relaxed">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-10">{children}</div>}
      </div>
    </div>
  </section>
);

export default PageHero;
